// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_bjXXuR6Iu7Io5WlSf_G"};